import React, { useEffect, useState } from 'react'
import { useSelectorCustom } from '../../../components/general/general-component/abstruct-component/useSelectorCustom'
import { AbstructVar } from '../../../components/general/general-component/abstruct-component/AbstructVar'
import { AbstructLang } from '../../../components/general/general-component/abstruct-component/AbstructLang'
import { DeleteComponent } from '../../../components/general/general-component/abstruct-component/DeleteComponent'
import SectionTopOfTable from '../../../components/general/general-component/section-top-of-table/SectionTopOfTable'
import Table2 from '../../../components/table/Table2'
import InnerLoader from '../../../components/general/inner-loader/InnerLoader'
import Warning from '../../../components/general/general-component/warning-delete/Warning'
import { VariableTransactions } from './VariableTransactions'
import { cancelTransaction, loadTransactions } from '../../../store/Actions/ActionTransactions'
import { ColumnTransactions } from '../../../components/general/general-component/columns-component/ColumnTransactions'
import AddTransaction from './AddTransaction'
import EditTransaction from './EditTransaction'
import FilterTransactions from './FilterTransactions'
import { UsePermissions, hasPermissions } from '../../../components/general/general-component/abstruct-component/UsePermissions'
import CheckPermissions from '../../../components/general/general-component/check-permissions'
import CheckLazyLoader from '../../../components/general/general-component/check-lazy-loader'


const AllTransactions = () => {
    const { permissionss, loadingMainPermission } = UsePermissions();
    const expenses_transactions = hasPermissions([{ name: "expenses-transactions" }], permissionss);
    const { dispatch, langLocal, navigate } = AbstructVar()
    const { translate } = AbstructLang()
    const { transactions, loadingTransactions } = useSelectorCustom()
    const { state, setOpen, handleEdit, setopenEdit } = VariableTransactions()
    const { stateD, warning, setdeletee, setloadDel } = DeleteComponent()
    const [transactionsArr, setTransactionsArr] = useState([])
    const [isDeleted, setIsDeleted] = useState('')
    const [idDeleted, setIdDeleted] = useState(null)
    useEffect(() => {
        if (isDeleted && idDeleted) {
            const updatedArr = [...transactionsArr];
            const indexToDelete = updatedArr.findIndex(item => item.id === idDeleted);
            if (indexToDelete !== -1) {
                updatedArr.splice(indexToDelete, 1);
                setTransactionsArr(updatedArr);
            }
        }
    }, [isDeleted, idDeleted, transactionsArr]);
    useEffect(() => {
        if (transactions?.length >= 0) {
            setTransactionsArr(transactions)
        }
    }, [transactions]);
    useEffect(() => {
        dispatch(loadTransactions())
    }, []);
    const handleDelete = (id) => {
        dispatch(cancelTransaction(id, setloadDel, setIsDeleted, setIdDeleted));
    }
    const openAddTransaction = e => {
        e.preventDefault()
        setOpen(true)
    }
    const { columns } = ColumnTransactions(translate, warning, langLocal, handleEdit)
    return (
        <CheckLazyLoader>
            <CheckPermissions array={expenses_transactions} loadingMainPermission={loadingMainPermission} >
                <main>
                    <div className="margin_main shadow_main">
                        <FilterTransactions translate={translate} />
                    </div>
                    <div className="div_table margin_main shadow_main" dir={langLocal == "ar" ? "rtl" : "ltr"} >

                        <SectionTopOfTable langLocal={langLocal} title={translate('transactions')} titleBtn={translate('add_transaction')} FunctionBtn={openAddTransaction} />
                        {
                            loadingTransactions ? <InnerLoader /> :
                                <Table2 col={columns} roo={transactionsArr} />
                        }
                    </div>
                </main>
            </CheckPermissions>
            {
                stateD.deletee == true ? (
                    <Warning loadDel={stateD.loadDel} arr={stateD.arrW} open={stateD.deletee} setOpen={setdeletee} handleDelete={handleDelete} />
                ) : <></>
            }
            {
                state.open && (
                    <AddTransaction isAccount={true} isTransactionType={true} open={state.open} setOpen={setOpen} />
                )
            }
            {
                state.openEdit && (
                    <EditTransaction arr={state.arr1} open={state.openEdit} setOpen={setopenEdit} />
                )
            }
        </CheckLazyLoader>
    )
}

export default AllTransactions


